"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var analysis_1 = require("../features/apis/analysis");
var area_change_1 = require("../features/apis/area-change");
var asset_document_1 = require("../features/apis/asset-document");
var auth_1 = require("../features/apis/auth");
var billable_line_item_1 = require("../features/apis/billable-line-item");
var billing_1 = require("../features/apis/billing");
var billing_alteration_1 = require("../features/apis/billing-alteration");
var billing_period_1 = require("../features/apis/billing-period");
var building_1 = require("../features/apis/building");
var building_area_1 = require("../features/apis/building-area");
var building_invoice_config_1 = require("../features/apis/building-invoice-config");
var building_area_config_1 = require("../features/apis/building-area-config");
var meter_premise_config_1 = require("../features/apis/meter-premise-config");
var building_slip_config_1 = require("../features/apis/building-slip-config");
var change_event_removal_request_1 = require("../features/apis/change-event-removal-request");
var charge_1 = require("../features/apis/charge");
var client_1 = require("../features/apis/client");
var credit_note_1 = require("../features/apis/credit-note");
var custom_rate_1 = require("../features/apis/custom-rate");
var invoice_1 = require("../features/apis/invoice");
var luam_1 = require("../features/apis/luam");
var meter_1 = require("../features/apis/meter");
var meter_reading_1 = require("../features/apis/meter-reading");
var municipality_1 = require("../features/apis/municipality");
var notification_1 = require("../features/apis/notification");
var occupancy_1 = require("../features/apis/occupancy");
var rate_periods_1 = require("../features/apis/rate-periods");
var service_1 = require("../features/apis/service");
var slip_1 = require("../features/apis/slip");
var supplier_bill_1 = require("../features/apis/supplier-bill");
var telemetry_1 = require("../features/apis/telemetry");
var tenant_1 = require("../features/apis/tenant");
var tenant_invoice_1 = require("../features/apis/tenant-invoice");
var usage_1 = require("../features/apis/usage");
var user_1 = require("../features/apis/user");
var xero_1 = require("../features/apis/xero");
var auth_2 = require("../features/slices/auth");
var common_1 = require("../features/slices/common");
var content_dialog_1 = require("../features/slices/content-dialog");
var message_dialog_1 = require("../features/slices/message-dialog");
exports.store = (0, toolkit_1.configureStore)({
    devTools: process.env.ENVIRONMENT !== "PROD",
    reducer: (_a = {
            auth: auth_2.authReducer,
            common: common_1.commonReducer,
            messageDialog: message_dialog_1.messageDialogReducer,
            contentDialog: content_dialog_1.contentDialogReducer
        },
        _a[analysis_1.analysisApi.reducerPath] = analysis_1.analysisApi.reducer,
        _a[auth_1.authApi.reducerPath] = auth_1.authApi.reducer,
        _a[user_1.userApi.reducerPath] = user_1.userApi.reducer,
        _a[client_1.clientApi.reducerPath] = client_1.clientApi.reducer,
        _a[building_1.buildingApi.reducerPath] = building_1.buildingApi.reducer,
        _a[area_change_1.areaChangeApi.reducerPath] = area_change_1.areaChangeApi.reducer,
        _a[building_area_1.buildingAreaApi.reducerPath] = building_area_1.buildingAreaApi.reducer,
        _a[building_invoice_config_1.buildingInvoiceConfigApi.reducerPath] = building_invoice_config_1.buildingInvoiceConfigApi.reducer,
        _a[building_area_config_1.buildingAreaConfigApi.reducerPath] = building_area_config_1.buildingAreaConfigApi.reducer,
        _a[meter_premise_config_1.meterPremiseConfigApi.reducerPath] = meter_premise_config_1.meterPremiseConfigApi.reducer,
        _a[building_slip_config_1.buildingSlipConfigApi.reducerPath] = building_slip_config_1.buildingSlipConfigApi.reducer,
        _a[change_event_removal_request_1.changeEventRemovalRequestApi.reducerPath] = change_event_removal_request_1.changeEventRemovalRequestApi.reducer,
        _a[luam_1.luamApi.reducerPath] = luam_1.luamApi.reducer,
        _a[meter_1.meterApi.reducerPath] = meter_1.meterApi.reducer,
        _a[meter_reading_1.meterReadingApi.reducerPath] = meter_reading_1.meterReadingApi.reducer,
        _a[tenant_1.tenantApi.reducerPath] = tenant_1.tenantApi.reducer,
        _a[tenant_invoice_1.tenantInvoiceApi.reducerPath] = tenant_invoice_1.tenantInvoiceApi.reducer,
        _a[occupancy_1.occupancyApi.reducerPath] = occupancy_1.occupancyApi.reducer,
        _a[service_1.serviceApi.reducerPath] = service_1.serviceApi.reducer,
        _a[charge_1.chargeApi.reducerPath] = charge_1.chargeApi.reducer,
        _a[custom_rate_1.customRateApi.reducerPath] = custom_rate_1.customRateApi.reducer,
        _a[credit_note_1.creditNoteApi.reducerPath] = credit_note_1.creditNoteApi.reducer,
        _a[invoice_1.invoiceApi.reducerPath] = invoice_1.invoiceApi.reducer,
        _a[billing_1.billingApi.reducerPath] = billing_1.billingApi.reducer,
        _a[billing_alteration_1.billingAlterationApi.reducerPath] = billing_alteration_1.billingAlterationApi.reducer,
        _a[billable_line_item_1.billableLineItemApi.reducerPath] = billable_line_item_1.billableLineItemApi.reducer,
        _a[billing_period_1.billingPeriodApi.reducerPath] = billing_period_1.billingPeriodApi.reducer,
        _a[slip_1.slipApi.reducerPath] = slip_1.slipApi.reducer,
        _a[rate_periods_1.ratePeriodApi.reducerPath] = rate_periods_1.ratePeriodApi.reducer,
        _a[municipality_1.municipalityApi.reducerPath] = municipality_1.municipalityApi.reducer,
        _a[asset_document_1.assetDocumentApi.reducerPath] = asset_document_1.assetDocumentApi.reducer,
        _a[supplier_bill_1.supplierBillApi.reducerPath] = supplier_bill_1.supplierBillApi.reducer,
        _a[notification_1.notificationApi.reducerPath] = notification_1.notificationApi.reducer,
        _a[usage_1.usageApi.reducerPath] = usage_1.usageApi.reducer,
        _a[telemetry_1.telemetryApi.reducerPath] = telemetry_1.telemetryApi.reducer,
        _a[xero_1.xeroApi.reducerPath] = xero_1.xeroApi.reducer,
        _a),
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware().concat([
            analysis_1.analysisApi.middleware,
            auth_1.authApi.middleware, //
            user_1.userApi.middleware,
            client_1.clientApi.middleware,
            building_1.buildingApi.middleware,
            area_change_1.areaChangeApi.middleware,
            building_area_1.buildingAreaApi.middleware,
            building_invoice_config_1.buildingInvoiceConfigApi.middleware,
            building_area_config_1.buildingAreaConfigApi.middleware,
            meter_premise_config_1.meterPremiseConfigApi.middleware,
            building_slip_config_1.buildingSlipConfigApi.middleware,
            change_event_removal_request_1.changeEventRemovalRequestApi.middleware,
            luam_1.luamApi.middleware,
            meter_1.meterApi.middleware,
            meter_reading_1.meterReadingApi.middleware,
            tenant_1.tenantApi.middleware,
            tenant_invoice_1.tenantInvoiceApi.middleware,
            occupancy_1.occupancyApi.middleware,
            service_1.serviceApi.middleware,
            charge_1.chargeApi.middleware,
            custom_rate_1.customRateApi.middleware,
            credit_note_1.creditNoteApi.middleware,
            invoice_1.invoiceApi.middleware,
            billing_1.billingApi.middleware,
            billing_alteration_1.billingAlterationApi.middleware,
            billable_line_item_1.billableLineItemApi.middleware,
            billing_period_1.billingPeriodApi.middleware,
            slip_1.slipApi.middleware,
            rate_periods_1.ratePeriodApi.middleware,
            municipality_1.municipalityApi.middleware,
            asset_document_1.assetDocumentApi.middleware,
            supplier_bill_1.supplierBillApi.middleware,
            notification_1.notificationApi.middleware,
            usage_1.usageApi.middleware,
            telemetry_1.telemetryApi.middleware,
            xero_1.xeroApi.middleware,
        ]);
    },
});
